const AriaAppLogo = () => {
  return (
    <svg viewBox="0 0 1080 1080">
      <path
        d="M761,535.9C653.7,293.3,655.5,73,655.5,73L425,73.9c8.3,172.2-105.5,464.7-105.5,464.7c204.6,142.5,212,327.7,212,327.7L500.9,895l33.3,40.8l-30.5,33.3l38.9,38.9l33.3-38.9l-33.3-33.3l37-38.9l-31.4-31.5C585.1,650.6,761,535.9,761,535.9z M634.2,548.8C562.9,621,468.5,596,425,522.9c-43.5-73.1,0-185.1,101.8-195.3c0,0,57.4-7.4,109.3,39.8L526.8,477.6l-46.3-44.4l-21.3,23.1l66.7,64.8l129.6-125.9C655.5,395.1,705.5,476.6,634.2,548.8z"
        style={{ fill: "#20438E" }}
      />
    </svg>
  );
};

export default AriaAppLogo;
